import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    container: { maxHeight: 200, overflowY: "auto", paddingRight: theme.spacing(3) },
    title: { fontWeight: 600 },
    list: { margin: 0, paddingLeft: theme.spacing(5) },
    content: { marginBottom: theme.spacing(4) },
    buttonBox: { display: "flex", justifyContent: "space-between", marginTop: theme.spacing(5) },
    buttonSubBox: { display: "flex", gap: theme.spacing(1) },
    toogleIcon: { fontSize: 18, color: theme.palette.emteria.text.secondary },
    editorContainer: { flex: 1, maxWidth: "50vw" },
    notesContainer: { display: "flex", flexDirection: "column", gap: theme.spacing(2), maxWidth: "50vw" },
}));
